








































import {Component, Prop, Vue} from "vue-property-decorator";
import Customer from "@/api/Customer";
import CustomerService from "@/service/CustomerService";
import RenderModal from "@/components/Shared/RenderModal.vue";
import CustomerPassword from "@/api/Customer/CustomerPassword";

@Component({
  components: {RenderModal}
})
export default class CustomerPasswordEditFormView extends Vue {
  @Prop() private customer!: Customer;
  private customerPassword = new CustomerPassword();

  closeForm(saved = false) {
    this.$emit('close-customer-info-form', {saved: saved});
  }

  async saveCustomerPassword(){
    const response = await CustomerService.saveCustomerPassword(this.customerPassword);
    if(response.success){
      this.closeForm(true);
    }else{
      alert(response.message);
    }
  }
}
